export const formatCharactersForUrlPathname = (
  urlStr: string,
  space: string,
  equalLength: boolean
): string => {
  let str: string = urlStr;
  if (!str) {
    return '';
  }
  // lowercase the string
  str = str.toLowerCase();

  let result: string = '';
  for (let i: number = 0; i < str.length; i++) {
    const c: string = str.charAt(i);
    switch (c) {
      case ' ':
      case '+':
        if (
          equalLength ||
          (result.length > 0 &&
            result.charAt(result.length - 1) != '-' &&
            result.charAt(result.length - 1) != '+')
        ) {
          result += space;
        }
        break;
      case "'":
      case '’':
      case '.':
        if (equalLength) {
          result += '-';
        }
        break;
      case '-':
      case '\\':
      case '?':
      case '&':
      case '_':
      case '"':
      case '“':
      case '”':
        if (
          equalLength ||
          (result.length > 0 &&
            result.charAt(result.length - 1) != '-' &&
            result.charAt(result.length - 1) != '+')
        ) {
          if (i + 1 < str.length && str.charAt(i + 1) == ' ') {
            result += space;
          } else {
            result += '-';
          }
        }
        break;
      case 'Ä':
      case 'ä':
      case 'Æ':
      case 'æ':
        if (equalLength) {
          result += 'ä';
        } else {
          result += 'ae';
        }
        break;
      case 'Ö':
      case 'ö':
      case 'Œ':
      case 'œ':
        if (equalLength) {
          result += 'ö';
        } else {
          result += 'oe';
        }
        break;
      case 'Ü':
      case 'ü':
        if (equalLength) {
          result += 'ü';
        } else {
          result += 'ue';
        }
        break;
      case 'ß':
        if (equalLength) {
          result += 'ß';
        } else {
          result += 'ss';
        }
        break;
      case 'À':
      case 'à':
      case 'Â':
      case 'â':
      case 'Á':
      case 'á':
      case 'Ą':
      case 'ą':
      case 'Å':
      case 'å':
        result += 'a';
        break;
      case 'Ć':
      case 'ć':
      case 'Ç':
      case 'ç':
        result += 'c';
        break;
      case 'Ę':
      case 'ę':
      case 'È':
      case 'è':
      case 'É':
      case 'é':
      case 'Ë':
      case 'ë':
      case 'Ê':
      case 'ê':
        result += 'e';
        break;
      case 'Ì':
      case 'ì':
      case 'ı':
      case 'Í':
      case 'í':
      case 'Î':
      case 'î':
      case 'Ï':
      case 'ï':
        result += 'i';
        break;
      case 'Ł':
      case 'ł':
        result += 'l';
        break;
      case 'Ń':
      case 'ń':
      case 'Ñ':
      case 'ñ':
        result += 'n';
        break;
      case 'Ó':
      case 'ó':
      case 'Ô':
      case 'ô':
      case 'Ò':
      case 'ò':
      case 'Õ':
      case 'õ':
      case 'Ø':
      case 'ø':
        result += 'o';
        break;
      case 'Ś':
      case 'ś':
      case 'š':
        result += 's';
        break;
      case 'Ù':
      case 'ù':
      case 'Û':
      case 'û':
      case 'Ú':
      case 'ú':
        result += 'u';
        break;
      case 'Ź':
      case 'ź':
      case 'Ż':
      case 'ż':
      case 'ž':
        result += 'z';
        break;
      case 'Ÿ':
      case 'ÿ':
      case 'Ý':
      case 'ý':
        result += 'y';
        break;
      case '[':
        if (equalLength) {
          result += space;
        } else {
          result += '%5B';
        }
        break;
      case ']':
        if (equalLength) {
          result += space;
        } else {
          result += '%5D';
        }
        break;
      case 'a':
      case 'b':
      case 'c':
      case 'd':
      case 'e':
      case 'f':
      case 'g':
      case 'h':
      case 'i':
      case 'j':
      case 'k':
      case 'l':
      case 'm':
      case 'n':
      case 'o':
      case 'p':
      case 'q':
      case 'r':
      case 's':
      case 't':
      case 'u':
      case 'v':
      case 'w':
      case 'x':
      case 'y':
      case 'z':
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        result += c;
        break;
      default:
        if (equalLength) {
          result += c;
        }
    }
  }
  str = result.toString();
  if (!equalLength) {
    str = strip(str, '-');
    str = strip(str, '+');
  }

  return str;
};

const strip = (stripStr: string, c: string): string => {
  let str: string = stripStr;
  while (str.startsWith(c)) {
    str = str.substring(1);
  }
  while (str.endsWith(c)) {
    str = str.substring(0, str.length - 1);
  }
  return str;
};
